import axiosClient from '@/services/axios';
import { buildQueryString } from '@/utils/string';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchSuggestedItemsInitial = createAsyncThunk(
  'suggestedItems/fetchSuggestedItemsInitial',
  async (_, { getState, rejectWithValue }) => {
    let filterObj;

    try {
      let url = '';
      filterObj = {
        page: 1,
        limit: 12,
      };

      url = `/api/suggested-items${buildQueryString(filterObj)}`;

      const result = await axiosClient.get(url);

      return result.data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const fetchSuggestedItems = createAsyncThunk(
  'suggestedItems/fetchSuggestedItems',
  async (_, { getState, rejectWithValue }) => {
    const { page, limit, filters, selectedFilterItems } =
      getState().suggestedItems;

    let queryString = '';
    let filterObj;

    try {
      let url = '';

      if (selectedFilterItems?.length > 0) {
        const grouped = selectedFilterItems.reduce((acc, { key, id }) => {
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(id);
          return acc;
        }, {});

        queryString = Object.entries(grouped)
          .map(([key, ids]) => `${key}=${ids.reverse().join(',')}`)
          .join('&');
      }

      // Create a new object while conditionally excluding order_by if it's "default"
      const updatedFilter = {
        ...filters,
        ...(filters.order_by === 'default' ? { order_by: undefined } : {}),
      };

      // Remove `undefined` keys (optional, but recommended)
      Object.keys(updatedFilter).forEach(
        (key) => updatedFilter[key] === undefined && delete updatedFilter[key],
      );

      filterObj = {
        ...updatedFilter,
        page,
        limit,
      };

      url =
        queryString.length > 0
          ? `/api/suggested-items${buildQueryString(filterObj)}&${queryString}`
          : `/api/suggested-items${buildQueryString(filterObj)}`;

      const result = await axiosClient.get(url);

      return result.data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const fetchInfinitySuggestedItems = createAsyncThunk(
  'suggestedItems/fetchInfinitySuggestedItems',
  async (_, { getState, rejectWithValue }) => {
    const { page, limit, filters, selectedFilterItems } =
      getState().suggestedItems;

    let queryString = '';
    let filterObj;

    try {
      let url = '';

      if (selectedFilterItems?.length > 0) {
        const grouped = selectedFilterItems.reduce((acc, { key, id }) => {
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(id);
          return acc;
        }, {});

        queryString = Object.entries(grouped)
          .map(([key, ids]) => `${key}=${ids.reverse().join(',')}`)
          .join('&');
      }

      // Create a new object while conditionally excluding order_by if it's "default"
      const updatedFilter = {
        ...filters,
        ...(filters.order_by === 'default' ? { order_by: undefined } : {}),
      };

      // Remove `undefined` keys (optional, but recommended)
      Object.keys(updatedFilter).forEach(
        (key) => updatedFilter[key] === undefined && delete updatedFilter[key],
      );

      filterObj = {
        ...updatedFilter,
        page,
        limit,
      };

      url =
        queryString.length > 0
          ? `/api/suggested-items${buildQueryString(filterObj)}&${queryString}`
          : `/api/suggested-items${buildQueryString(filterObj)}`;

      const result = await axiosClient.get(url);

      return result.data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getSuggestedItemsFilterKey = createAsyncThunk(
  'suggestedItems/getSuggestedItemsFilterKey',
  async (_, { rejectWithValue }) => {
    try {
      const url = `/api/suggested-items-filter`;

      const result = await axiosClient.get(url);

      return result.data?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
